export type OrderMetaKv = { key?: string | null; value?: string | null }

const TIKTOK_ORDER_ID_IN_TAGS = /TikTokOrderID:\s*(\d+)/i
const TIKTOK_ORDER_ID_ALT = /tiktokOrderId:\s*(\d+)/i

export function getTiktokOrderNumberFromMetadata(
  order_metadata?: OrderMetaKv[] | null,
): string | null {
  if (!order_metadata?.length) return null
  const shopifyTags = order_metadata.find((m) => m.key === 'shopify_tags')?.value
  if (shopifyTags == null || shopifyTags === '') return null
  const s = String(shopifyTags)
  const primary = s.match(TIKTOK_ORDER_ID_IN_TAGS)
  if (primary) return primary[1]
  const alt = s.match(TIKTOK_ORDER_ID_ALT)
  return alt ? alt[1] : null
}

const TIKTOK_SUBDOMAIN_HOST_DEFAULT = 'tiktok.orderlookup.dangleit.com'

/** Matches `middleware` / `TIKTOK_SUBDOMAIN_HOST` (via `next.config.js` → `NEXT_PUBLIC_TIKTOK_SUBDOMAIN_HOST`). */
export function isTiktokHost(): boolean {
  if (typeof window === 'undefined') return false
  const expected =
    process.env.NEXT_PUBLIC_TIKTOK_SUBDOMAIN_HOST ?? TIKTOK_SUBDOMAIN_HOST_DEFAULT
  return window.location.hostname.toLowerCase() === expected.toLowerCase()
}

export function getOrderSelectLabel(
  orderItem: {
    source_id: string
    order_metadata?: OrderMetaKv[] | null
  },
): string {
  if (isTiktokHost()) {
    return getTiktokOrderNumberFromMetadata(orderItem.order_metadata) ?? orderItem.source_id
  }
  return orderItem.source_id
}
